import React from 'react';
import { Link } from 'react-router-dom';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';

export default function NotFound() {
  const { t } = useLang();
  usePageTitle(t.notFound.title);
  return (
    <section className="section not-found">
      <div className="container center">
        <p className="not-found__code">404</p>
        <h1 className="section-title">{t.notFound.title}</h1>
        <p className="section-lead">{t.notFound.text}</p>
        <Link to="/" className="btn btn--primary mt-4">
          {t.notFound.back}
        </Link>
      </div>
    </section>
  );
}
